import { FormSelect } from '@systemeio/ui'
import EditActionWrapper from 'modules/automation-rules/actions/components/edit-actions/components/edit-action-wrapper'
import { EditActionItemInterface } from 'modules/automation-rules/actions/components/edit-actions/types/edit-action-item-interface'
import { ActionPipelineStageEditInterface } from 'modules/automation-rules/actions/types/automation-rule-actions-edit-interface'
import { getData, getDataFromObj } from 'modules/automation-rules/utils/get-filter-data'
import { usePipelineStageList } from 'modules/crm/pipeline/hooks/use-pipeline-stage-list'
import React from 'react'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { OpenInNewIcon } from '@systemeio/ui/icons'

interface ActionAssignPipelineStageItemProps
  extends EditActionItemInterface<ActionPipelineStageEditInterface> {}

const ActionAssignPipelineStageItem = ({
  actions,
  action,
  onDelete,
  setRules,
  errors,
  idx,
}: ActionAssignPipelineStageItemProps) => {
  const { t } = useLocoTranslation()

  const { pipelineStage, isLoading } = usePipelineStageList(action.pipelineStage.pipeline.id)

  return (
    <EditActionWrapper slug={action.type} onDelete={() => onDelete(idx)}>
      {({ data, onOpen, renderActionLabel }) => (
        <>
          <FormSelect
            onOpen={onOpen}
            label={renderActionLabel({
              label: t('dashboard.automation_rule.crm.label_pipeline'),
              additionalLabel: action.pipelineStage.id ? (
                <LinkWithoutPrefetch
                  rel="noreferrer"
                  target={'_blank'}
                  className={`group self-center outline-hidden`}
                  href={'/crm-pipeline'}
                >
                  <OpenInNewIcon
                    className={
                      'main-transition-colors group-focus-visible:fill-brand-primary hover:fill-brand-primary'
                    }
                  />
                </LinkWithoutPrefetch>
              ) : undefined,
            })}
            placeholder={t('dashboard.automation_rule.crm.select_pipeline')}
            value={action.pipelineStage.pipeline.id}
            data={data.pipelineData}
            staticData={getDataFromObj(action.pipelineStage.pipeline)}
            onChange={data =>
              setRules(prev => {
                return {
                  ...prev,
                  actions: actions.map((el, i) => {
                    if (idx === i) {
                      return {
                        ...el,
                        pipelineStage: { pipeline: { id: data } },
                      }
                    } else {
                      return el
                    }
                  }),
                }
              })
            }
          />
          {action.pipelineStage.pipeline.id && (
            <FormSelect
              required
              label={t('dashboard.automation_rule.crm.label_stage')}
              placeholder={t('dashboard.automation_rule.crm.select_stage')}
              data={pipelineStage ? getData(Object.values(pipelineStage?.items)) : undefined}
              value={action.pipelineStage.id}
              onChange={data =>
                setRules(prev => {
                  return {
                    ...prev,
                    actions: actions.map((el, i) => {
                      if (idx === i) {
                        return {
                          ...el,
                          pipelineStage: {
                            pipeline: { id: action.pipelineStage.pipeline.id },
                            id: data,
                          },
                        }
                      } else {
                        return el
                      }
                    }),
                  }
                })
              }
              error={errors.automationActions[action.id]?.pipelineStage?.join('')}
              isPreFetching={isLoading}
            />
          )}
        </>
      )}
    </EditActionWrapper>
  )
}
export default ActionAssignPipelineStageItem
